// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"5e9b629e","531":"d2e80693","727":"cf1fcf95","967":"b4ffd393"}[chunkId] + ".chunk.js";
};